// TODO: move these to generated enums

enum SelectAction {
  Simple = 'simple',
  Toggle = 'toggle',
  Range = 'range',
  Menu = 'menu'
}

export { SelectAction };
